import Layout from "@/components/Layout";
import { useAuth } from "@/lib/auth";
import { t } from "@/lib/i18n";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { lang } = useAuth();
  return (
    <Layout>
      <div className="max-w-lg mx-auto px-6 py-24 text-center">
        <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mx-auto text-slate-500">
          <XCircle className="w-8 h-8" />
        </div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-[#1E3A8A] mt-6">
          {t(lang, "payment_cancel_title")}
        </h1>
        <p className="text-slate-600 mt-3">{t(lang, "payment_cancel_sub")}</p>
        <div className="mt-8 flex gap-3 justify-center flex-wrap">
          <Link to="/pricing">
            <Button data-testid="payment-retry-btn" className="rounded-full bg-[#F97316] hover:bg-[#EA580C]">{t(lang, "view_pricing")}</Button>
          </Link>
          <Link to="/company">
            <Button variant="outline" className="rounded-full">{t(lang, "back_to_dashboard")}</Button>
          </Link>
        </div>
      </div>
    </Layout>
  );
}
